import SinglePreviewCard from "components/campaignStreamline/SinglePreviewCard";
import MessageOverviewTableSection from "components/message/MessageOverviewTableSection";
import { DISPLAY_TARGET_CUSTOMER_TYPE, WEEKDAY } from "config/CustomEnums";
import { STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY } from "config/PageAnchorConfig/StampCampaignAnchorConfig";
import { ProcessEnvConfig } from "config/ProcessEnvConfig";
import { getDisplayRecurringPeriod } from "models/CreateCampaignModel";
import React from "react";
import { connect } from "react-redux";
import { getReadablePeriod } from "utils/TimeFormatUtil";


const getStampCampaignContentCard = (campaignData) => [
  {
    step: 0,
    sectionTitle: "GENERAL",
    anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.general.sectionKey,
    sectionContent: [
      {
        haveTranslation: true,
        isMandatory: true,
        title: "name",
        field: 'generalName',
        anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.general.sectionContent.general_name_key,
      },
      {
        haveTranslation: true,
        isRichText: true,
        title: "short_description",
        field: 'shortDescription',
        anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.general.sectionContent.short_description_optional_key,
      },
      {
        title: "Related brand",
        field: 'linkedBrandName',
        anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.general.sectionContent.related_brand_optional_key,
      },
    ]
  },
  {
    step: 0,
    sectionTitle: "TARGET CUSTOMER",
    anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.targetCustomers.sectionKey,
    sectionContent: [
      {
        isMandatory: true,
        title: "Target customer",
        field: 'readableGeneralType',
        anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.targetCustomers.sectionContent.is_exclusive_campaign_key,
      },
      {
        isMandatory: true,
        title: "Select segments",
        field: 'readableSelectSegments',
        anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.targetCustomers.sectionContent.target_customer_selector_key,
      },
      {
        title: "Dynamic segment",
        field: 'readableDynamicSegments',
        errorField: 'segments',
        anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.targetCustomers.sectionContent.target_customer_selector_key,
      },
      {
        title: "Static segment",
        field: 'readableStaticSegments',
        errorField: 'segments',
        anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.targetCustomers.sectionContent.target_customer_selector_key,
      },
      {
        title: "Levels",
        field: 'readableLevels',
        errorField: 'levels',
        anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.targetCustomers.sectionContent.target_customer_selector_key,
      },
      {
        isMandatory: true,
        isBoolean: true,
        title: "Blacklist customers by segments",
        field: 'excludeBlacklistSegment',
        anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.targetCustomers.sectionContent.exclude_blacklist_segment_switch_key,
      },
      {
        isMandatory: campaignData?.excludeBlacklistSegment,
        title: "Blacklist segment",
        field: 'readableBlacklistSegments',
        errorField: "blacklistSegments",
        anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.targetCustomers.sectionContent.exclude_blacklist_segment_switch_key,
      },
    ]
  },
  {
    step: 0,
    sectionTitle: "KEY VISUAL",
    anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.keyVisual.sectionKey,
    sectionContent: [
      {
        haveTranslation: true,
        isMandatory: true,
        isImage: true,
        title: "cover_photo",
        field: 'coverPhoto',
        anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.keyVisual.sectionContent.cover_photo_upload_key,
      },
      {
        isMandatory: true,
        isBoolean: true,
        title: "Apply to all language",
        field: 'applyCoverPhotoToAllLanguage',
        anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.keyVisual.sectionContent.cover_photo_upload_key,
      },
      {
        haveTranslation: true,
        isImage: true,
        title: "other_photos",
        field: 'detailPhotos',
        anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.keyVisual.sectionContent.other_photo_upload_key,
      },
      {
        isMandatory: true,
        isBoolean: true,
        title: "Apply to all language",
        field: 'applyDetailPhotosToAllLanguage',
        anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.keyVisual.sectionContent.other_photo_upload_key,
      },
      {
        haveTranslation: true,
        isMandatory: true,
        isImage: true,
        title: "campaign.square_cover_photo",
        field: 'squareCoverPhoto',
        anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.keyVisual.sectionContent.square_cover_photo_upload_key,
      },
      {
        isMandatory: true,
        isBoolean: true,
        title: "Apply to all language",
        field: 'applySquareCoverPhotoToAllLanguage',
        anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.keyVisual.sectionContent.square_cover_photo_upload_key,
      },
      {
        isBoolean: true,
        title: "Upload stamp icons",
        field: 'useUploadStampIcons',
        anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.keyVisual.sectionContent.stamp_campaign_upload_stamp_icon_key,
      },
      {
        hide: !campaignData.useUploadStampIcons,
        isMandatory: true,
        isImage: true,
        title: "Empty Stamp slot",
        field: 'stampCampaignTypeEmptySlotStampImage',
        anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.keyVisual.sectionContent.stamp_campaign_upload_stamp_icon_key,
      },
      {
        hide: !campaignData.useUploadStampIcons,
        isMandatory: true,
        isImage: true,
        title: "Collected stamp",
        field: 'stampCampaignTypeAcquiredStampImage',
        anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.keyVisual.sectionContent.stamp_campaign_upload_stamp_icon_key,
      },
      {
        hide: !campaignData.useUploadStampIcons,
        isMandatory: true,
        isImage: true,
        title: "Empty gift stamp slot",
        field: 'stampCampaignTypeEmptyGiftSlotImage',
        anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.keyVisual.sectionContent.stamp_campaign_upload_stamp_icon_key,
      },
      {
        hide: !campaignData.useUploadStampIcons,
        isMandatory: true,
        isImage: true,
        title: "Collected gift",
        field: 'stampCampaignTypeCollectedGiftImage',
        anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.keyVisual.sectionContent.stamp_campaign_upload_stamp_icon_key,
      },
    ]
  },
  {
    step: 0,
    sectionTitle: "INSTRUCTION",
    anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.instruction.sectionKey,
    sectionContent: [
      {
        haveTranslation: true,
        title: "instruction_section_title",
        field: 'instructionSectionTitle',
        anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.instruction.sectionContent.instruction_section_key,
      },
      {
        haveTranslation: true,
        isRichText: true,
        title: "instruction_section_content",
        field: 'instructionSectionContent',
        anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.instruction.sectionContent.instruction_section_key,
      },
    ]
  },
  {
    step: 0,
    sectionTitle: "DETAIL",
    anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.detail.sectionKey,
    sectionContent: [
      {
        haveTranslation: true,
        title: "detail_section_title",
        field: 'detailSectionTitle',
        anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.detail.sectionContent.detail_section_key,
      },
      {
        haveTranslation: true,
        isRichText: true,
        title: "detail_section_content",
        field: 'detailSectionContent',
        anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.detail.sectionContent.detail_section_key,
      },
    ]
  },
  {
    step: 0,
    sectionTitle: "SHOW IN FRONTEND",
    anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.campaignListingSection.sectionKey,
    sectionContent: [
      {
        isMandatory: true,
        isBoolean: true,
        title: "Show in homepage banner",
        field: 'haveHomepageBanner',
        anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.campaignListingSection.sectionContent.homepage_banner_key,
      },
      {
        isMandatory: true,
        title: "Homepage banner visible period",
        field: 'homepageBannerVisiblePeriod',
        anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.campaignListingSection.sectionContent.banner_visible_period_key,
      },
      {
        haveTranslation: true,
        isMandatory: true,
        isImage: true,
        title: "homepageBannerImage",
        translationPrefix: "banner",
        field: 'coverPhotos',
        anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.campaignListingSection.sectionContent.banner_image_key,
      },
      {
        isMandatory: true,
        title: "Homepage banner display order",
        field: 'banner.order',
        anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.campaignListingSection.sectionContent.banner_display_order_key,
      },
      {
        isMandatory: true,
        isBoolean: true,
        title: "Show in homepage",
        field: 'isFeatured',
        anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.campaignListingSection.sectionContent.is_featured_campaign_key,
      },
      {
        isMandatory: true,
        isBoolean: true,
        title: "Show in campaign category",
        field: 'showInOfferTab',
        anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.campaignListingSection.sectionContent.show_in_offer_tab_key,
      },
      {
        isMandatory: true,
        title: "Campaign categories",
        field: 'readableCategories',
        anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.campaignListingSection.sectionContent.show_in_offer_tab_key,
      },
    ]
  },
  ...ProcessEnvConfig.haveShopMall? [
    {
      step: 0,
      sectionTitle: "MALL",
      anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.mall.sectionKey,
      sectionContent: [
        {
          title: "Mall",
          field: 'malls',
          anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.mall.sectionContent.visible_mall_key,
        },
      ]
    },
  ] : [],
  {
    step: 0,
    sectionTitle: "ACTIVE PERIOD",
    anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.activePeriod.sectionKey,
    sectionContent: [
      {
        title: "Active period",
        field: 'readableActivePeriod',
        anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.activePeriod.sectionContent.active_period_key,
      },
      {
        title: "Blackout period (by period)",
        field: 'readableBlackoutPeriod',
        anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.activePeriod.sectionContent.blackout_period_key,
      },
      {
        title: "Blackout period (by weekday)",
        field: 'readableBlackoutWeekday',
        anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.activePeriod.sectionContent.blackout_period_key,
      },
    ]
  },
  {
    step: 0,
    sectionTitle: "VISIBLE PERIOD",
    anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.visiblePeriod.sectionKey,
    sectionContent: [
      {
        title: "Visible period",
        field: 'readableVisiblePeriod',
        anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.visiblePeriod.sectionContent.visible_period_section_key,
      },
    ]
  },
  {
    step: 0,
    sectionTitle: "RECURRING CAMPAIGN",
    anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.recurringCampaign.sectionKey,
    sectionContent: [
      {
        isMandatory: true,
        isBoolean: true,
        title: "This is a recurring campaign for birthday",
        field: 'isBirthdayRecurringCampaign',
        anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.recurringCampaign.sectionContent.recurring_birthday_selector_key,
      },
      {
        isMandatory: true,
        title: "Recurring active period",
        field: 'readableRecurringActivePeriod',
        anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.recurringCampaignActivePeriod.sectionKey,
      },
      {
        isMandatory: true,
        title: "Recurring visible period",
        field: 'readableRecurringVisiblePeriod',
        anchorKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.recurringCampaignVisiblePeriod.sectionKey,
      },
    ]
  },
];
const StampCampaignPreviewContentCard = ({
  errors,
  campaignData,
  language,
  hideEditButton = false,
}) => {
  const contentData = {
    ...campaignData,
    "linkedBrandName": campaignData?.linkedBrand?.name,
    "readableGeneralType": campaignData?.isExclusive ? "Specific segments" : "All customers",
    "readableSelectSegments": DISPLAY_TARGET_CUSTOMER_TYPE?.[campaignData?.generalType] || campaignData?.generalType,
    "readableDynamicSegments": campaignData?.isExclusive && campaignData?.generalType === "DYNAMIC_SEGMENT"
      ? campaignData?.dynamicSegments?.map(item => item?.name)
      : null,
    "readableStaticSegments": campaignData?.isExclusive && campaignData?.generalType === "STATIC_SEGMENT"
      ? campaignData?.staticSegments?.map(item => item?.name)
      : null,
    "readableLevels": campaignData?.isExclusive && campaignData?.generalType === "LEVEL"
      ? campaignData?.levels?.map(item => item?.name)
      : null,
    "readableBlacklistSegments": campaignData?.excludeBlacklistSegment
      ? campaignData?.blacklistSegments?.map(item => item?.name)
      : null,
    "homepageBannerVisiblePeriod": getReadablePeriod(
      campaignData?.banner?.visiblePeriodStartDate,
      campaignData?.banner?.visiblePeriodEndDate,
      campaignData?.banner?.visiblePeriodFollowLinkedCampaign,
      "follow campaign"
    ),
    "readableCategories": campaignData?.showInOfferTab ? campaignData?.categories?.map(item => item?.name) : null,
    "readableActivePeriod": getReadablePeriod(
      campaignData.activeStartDate,
      campaignData.activeEndDate,
      campaignData.isAlwaysActivePeriod,
    ),
    "readableBlackoutPeriod": campaignData.activePeriodValues?.map((item) =>
      getReadablePeriod(item.startDate, item.endDate, false),
    ),
    "readableBlackoutWeekday": campaignData.activeWeekday?.map((item) => WEEKDAY[item]),
    "readableVisiblePeriod": getReadablePeriod(
      campaignData.visibleStartDate,
      campaignData.visibleEndDate,
      campaignData.isAlwaysVisiblePeriod,
    ),
    "readableRecurringActivePeriod": getDisplayRecurringPeriod({
      isForBirth: campaignData.isBirthdayRecurringCampaign,
      recurringDate: campaignData?.recurringDate,
      prefix: "Active"
    }),
    "readableRecurringVisiblePeriod": getDisplayRecurringPeriod({
      isForBirth: campaignData.isBirthdayRecurringCampaign,
      recurringDate: campaignData?.recurringDate,
      prefix: "Visible"
    })
  }
  return (
    <>
      <SinglePreviewCard
        language={language}
        data={contentData}
        cardInfo={getStampCampaignContentCard(contentData)}
        errors={errors}
        hideEditButton={hideEditButton}
      />
      <MessageOverviewTableSection
        message={contentData.recurringMessage}
        language={language}
        isRecurringMessage
        errors={errors}
        showEditButton
        prefix="recurringMessage."
        step={0}
      />
    </>)
}

const mapPropsToState = (state) => ({
  errors: state.createCampaign.errorFields,
});

export default connect(mapPropsToState)(StampCampaignPreviewContentCard);